import googleTagManagerId from "constants/googleTagManagerId";
import { useEnterWithGoogle } from "hooks/useEnterWithGoogle";
import React from "react";
import styled from "styled-components/macro";
import { mediaMin } from "styles/media";
import { ReactComponent as GoogleSVG } from "../../assets/google-logo.svg";

const StyledButton = styled.button`
  width: 100%;
  max-width: 454px;
  height: 48px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 13px;
  font-size: 13px;
  font-weight: 500;
  box-shadow: 1px 1px 4px 0 ${({ theme }) => theme.palette.black15};
  white-space: nowrap;
  border-radius: 24px;
  background-color: #4285f4;

  svg {
    background: #fff;
    width: 40px;
    padding: 11px;
    margin-right: 0;
    border-radius: 2px;
  }

  ${mediaMin.xs`
    height: 62px;
    border-radius: 31px;
    font-size: 15px;
  `};
`;

function GoogleSignInButton() {
  const handleClick = useEnterWithGoogle();

  return (
    <StyledButton
      type="button"
      onClick={handleClick}
      data-gtm-id={googleTagManagerId.LandingSignIn_GoogleSignIn_Button}
    >
      <GoogleSVG />
      Sign in with Google
    </StyledButton>
  );
}

export default GoogleSignInButton;
